import React from 'react'

import StarrySection from './Section'
import Uploader from 'components/EmbedForm/test-drive/Uploader'

// NOTE: string 'test-drive' in hash is used gatsby-browser.js
export const SCROLL_NAME = 'etch-test-drive'

export default function EtchTestDrive () {
  return (
    <StarrySection
      scrollName={SCROLL_NAME}
      title={
        <>
          Create & send an e-sign packet <span>in seconds</span> with Document
          AI
        </>
      }
      description="Upload any PDF and watch Anvil Document AI identify input and signature fields, identify signers and connects them to fields. It's free - no signup required."
      mode="etch"
    >
      <Uploader mode="etch" />
    </StarrySection>
  )
}
